import { ComponentType } from 'react'

import { useQuery } from '@apollo/client'
import { useFlags } from '@joor/launchdarkly-react-client-sdk'
import isEmpty from 'lodash/isEmpty'
import { useSelector } from 'react-redux'

import {
  ManualTransactionFragment,
  ManualTransactionsQuery,
  ManualTransactionsQueryVariables,
} from '__generated__/atlas-types'

import { toGlobalId } from 'utils/transformations/graphql'

import { atlasClient } from 'graphql/client'
import { getAccountId } from 'store/currentUser/selectors'

import { MANUAL_TRANSACTIONS_QUERY } from 'features/Orders/PublicInvoice/components/ManualTransactions/ManualTransactions.queries'

const withOrderManualPaymentRecords =
  (
    WrappedComponent: ComponentType<{
      manualPaymentRecords?: ManualTransactionFragment[]
    }>,
  ) =>
  (props: Record<string, string | Record<string, string>[]>) => {
    const accountId = useSelector(getAccountId)
    const { orders, canViewPaymentRecords } = props
    const { joorPayUseReach } = useFlags()
    const { data } = useQuery<
      ManualTransactionsQuery,
      ManualTransactionsQueryVariables
    >(MANUAL_TRANSACTIONS_QUERY, {
      variables: {
        accountId: toGlobalId('Account', accountId) || '',
        orderIds: Array.isArray(orders) ? orders.map((order) => order.id) : [],
      },
      client: atlasClient,
      skip:
        !joorPayUseReach ||
        isEmpty(orders) ||
        !canViewPaymentRecords ||
        !accountId,
    })

    return (
      <WrappedComponent
        {...props}
        manualPaymentRecords={data?.manualPaymentRecords}
      />
    )
  }

export default withOrderManualPaymentRecords
